/* eslint-disable no-console */
import { ApolloClient, from, InMemoryCache, ApolloLink } from "@apollo/client";
import { createUploadLink } from "apollo-upload-client";

import { onError } from "@apollo/client/link/error";

import Cookies from "js-cookie";

const { NODE_ENV } = process.env;

const isProduction = NODE_ENV === "production";

// this will forward graphql + networking errors to the browser console
const errorLink = onError(
  ({ graphQLErrors, networkError, operation, forward }) => {
    if (graphQLErrors) {
      graphQLErrors.map(({ message, locations, path }) =>
        console.error(
          `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path} 😞`
        )
      );
    }
    if (networkError) {
      console.error(`[Network error]: ${networkError} 😞`);
    }
    if (operation?.operationName === "MassUpdateWithCsv") {
      return null;
    } 
      return forward(operation);
  }
);

const uri = isProduction ? "/api" : "http://localhost:4000/graphql";

const authLink = new ApolloLink((operation, forward) => {
  const token = Cookies.get("DECCO_TOKEN");

  operation.setContext(({ headers }) => ({
    headers: { authorization: token ? `Bearer ${token}` : "", ...headers },
  }));

  return forward(operation);
});

const uploadLink = createUploadLink({
  uri,
});

const foundationUploadLink = createUploadLink({
  uri: isProduction ? "/foundation-api" : "http://localhost:4001/graphql",
});

export const FoundationApolloClient = new ApolloClient({
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          findManyUserGroupMemberships: {
            merge(existing = [], incoming) {
              return incoming;
            },
            findManyPackages: {
              merge(existing, incoming = []) {
                return [...incoming];
              },
            },
          },
        },
      },
    },
  }),
  link: from([errorLink, authLink, foundationUploadLink]),
});

export default new ApolloClient({
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          findManyUserGroupMemberships: {
            merge(existing = [], incoming) {
              return incoming;
            },
            findManyPackages: {
              merge(existing, incoming = []) {
                return [...incoming];
              },
            },
          },
        },
      },
    },
  }),
  link: from([errorLink, authLink, uploadLink]),
});
